import React from "react";
import UploadPage from "../../../supervise/components/SuperviseTable/component/UploadPage";
import styles from "./index.module.scss";

interface ButtonUploadPageProps {
    stuNo: string;
    examId: string;
    onChangeUploadLoading(val: boolean): void;
}

export function ButtonUploadPage({
    stuNo,
    examId,
    onChangeUploadLoading
}: ButtonUploadPageProps) {
    return (
        <div className={styles.buttonWrapper}>
            <UploadPage
                stuNo={stuNo}
                examId={examId}
                onChangeUploadLoading={onChangeUploadLoading}
            />
        </div>
    );
}
